import React, { Component, Fragment } from 'react';
import { render } from 'react-dom';
import PropTypes from 'prop-types';
import generateLink from '../helpers/generateLink';
import jsLang from '../lib/jslang';

class Search extends Component {
    constructor(props) {
        super(props);

        this.searchableItems = props.searchableitems;
        this.items = props.items;

        this.state = {
            searchTerm: '',
            searchResults: this.searchableItems,
        };

        this.handleChange = this.handleChange.bind(this);
        this.setSearchTerm = this.setSearchTerm.bind(this);
    }

    setSearchTerm(searchTerm) {
        this.setState({
            searchTerm,
        }, this.setSearchResults);
    }


    setSearchResults() {
        const { searchTerm } = this.state;

        const results = this.searchableItems.filter(item => item.name.toLowerCase().includes(searchTerm.toLowerCase()));

        this.setState({
            searchResults: results,
        });
    }

    handleChange(event) {
        this.setSearchTerm(event.target.value);
    }

    renderSearchResults() {
        const { searchableitemslink } = this.props;
        const { searchResults } = this.state;

        if (searchResults.length > 0) {
            return searchResults.map(item => (
                <li
                    id={ `search-${item.id}` }
                    key={ `search-${item.id}` }
                    className="block bold p-a-xxs"
                >
                    <a className="nav__link" href={ item.link ? item.link : generateLink(searchableitemslink, { id: item.id }) }>
                        { item.name }
                    </a>
                </li>
            ));
        }

        return (
            <li className="block bold p-a-xxs">
                { jsLang.get('common.noResults') }
            </li>
        );
    }

    renderItems() {
        const {
            searchableitemstitle,
            itemslink,
            itemstitle,
        } = this.props;

        return (
            <Fragment>
                <li className="block bold p-a-xxs bg-grey m-a-none">
                    <span className="nav__link m-l-xxs">
                        { itemstitle }
                    </span>
                </li>
                <li className="block bold p-a-xxs">
                    <a className="nav__link" href={ itemslink }>
                        { this.items.name }
                    </a>
                </li>
                <li className="block bold p-a-xxs bg-grey m-a-none">
                    <span className="nav__link m-l-xxs">
                        { searchableitemstitle }
                    </span>
                </li>
            </Fragment>
        );
    }

    render() {
        const { searchTerm } = this.state;

        return (
            <Fragment>
                <div className="p-v-xxs p-h-xs">
                    <input
                        type="text"
                        placeholder="Search"
                        value={ searchTerm }
                        onChange={ this.handleChange }
                        className="form__control form__field"
                    />
                </div>
                <ul className="list--no-style">
                    { this.items && this.renderItems() }
                    { this.renderSearchResults() }
                </ul>
            </Fragment>
        );
    }
}

Search.propTypes = {
    searchableitems: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    searchableitemslink: PropTypes.string,
    searchableitemstitle: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape()),
    itemslink: PropTypes.string,
    itemstitle: PropTypes.string,
};

Search.defaultProps = {
    items: [],
    itemslink: null,
    itemstitle: null,
    searchableitemslink: null,
    searchableitemstitle: null,
};

export default Search;

const elements = document.querySelectorAll('[data-js-module="search"]');

for (const element of elements) {
    const props = Object.assign({}, element.dataset);
    const items = JSON.parse(decodeURIComponent(props.items));
    const searchableitems = JSON.parse(decodeURIComponent(props.searchableitems));

    render(<Search { ...props } items={ items } searchableitems={ searchableitems } />, element);
}
